var reviewTabs = document.querySelectorAll('.review-tabs');
reviewTabs.forEach((container) => {
  container.classList.add('tab-js');
  container.querySelector('.review-tab').classList.add('active');
  container.querySelector('.review-tabpanel').classList.add('active');
  var tabs = container.querySelectorAll('.review-tab');
  tabs.forEach((tab) => {
    tab.addEventListener('click', (event) => {
      event.preventDefault();
      changeTabs(event);
    });
  });
  function changeTabs(event) {
    tabs.forEach((tab) => {
      tab.setAttribute('aria-selected', 'false');
      tab.classList.remove('active');
      document
        .getElementById(tab.getAttribute('aria-controls'))
        .classList.remove('active');
    });

    event.currentTarget.setAttribute('aria-selected', 'true');
    event.currentTarget.classList.add('active');
    document
      .getElementById(event.currentTarget.getAttribute('aria-controls'))
      .classList.add('active');
  }
});
